import { useImmer } from "use-immer";
import { useEffect } from "react";
import ApiConnector from "../connector/ApiConnector";
import { useHistory, useLocation } from "react-router-dom";
import RouteUtilService from "../service/RouteUtilService";
import ConfigService from "../service/ConfigService";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Component = (props) => {
  const [jobResultDetail, updateJobResultDetail] = useImmer(null);
  const [jobId, updateJobId] = useImmer(null);
  const [resultId, updateResultId] = useImmer(null);
  const location = useLocation();
  const history = useHistory();

  useEffect(async () => {
    const _jobId = RouteUtilService.getParam(location, "jobId");
    const _resultId = RouteUtilService.getParam(location, "resultId");
    const _jobResultDetail =
      await ApiConnector.getCalculateWeightsJobResultRowDetail(
        _jobId,
        _resultId,
      );
    updateJobResultDetail(_jobResultDetail);
    updateJobId(_jobId);
    updateResultId(_resultId);
  }, [location]);

  const setConfigWeights = async () => {
    const ok = ConfigService.createConfigWindowPrompt();
    if (!ok) {
      return;
    }
    await ApiConnector.setConfigWeights(jobId, resultId);
    window.alert(
      "New config has been created. You will be redirected to config page.",
    );
    history.push("/config");
  };

  return (
    <>
      <header className="subheader header-with-save">
        <h1>Simulation - Job result detail</h1>
      </header>
      <main>
        <div className="row">
          <div className="col">
            <h2>Weights</h2>
          </div>
          <div className="col-4">
            <h2 className="float-right">
              <FontAwesomeIcon
                icon={faFloppyDisk}
                className="icon-clickable"
                onClick={(e) => setConfigWeights()}
              />
            </h2>
          </div>
        </div>

        {jobResultDetail && (
          <>
            <table className="config-table">
              <thead>
                <tr>
                  <th>Weight name</th>
                  <th>Current config weight</th>
                  <th>Simulation weight</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(jobResultDetail.currentWeightConfig).map(
                  ([key, value]) => (
                    <tr key={key}>
                      <td>{key}</td>
                      <td>{value}</td>
                      <td>
                        {jobResultDetail.jobResultWeightConfig[key] != null
                          ? jobResultDetail.jobResultWeightConfig[key]
                          : "Not calculated. Use: " + value}
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          </>
        )}
      </main>
    </>
  );
};

export default Component;
